import React from "react";
import { FieldRendererProps } from "../types";
import {
  FileInput, VideoUploadContainer, UploadIcon, UploadText,
  VideoContainer, VideoPreview, VideoControls, VideoButton,
  ErrorMessage, PremiumWarning,
} from "../styles";
import { TipoFormulario } from "../../../services/constantes";
import { FaVideo, FaVideoSlash, FaCamera, FaTrash, FaTimes, FaStar } from "react-icons/fa";

export const VideoFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, errors, planoPremium,
  videoPreview, dragActive,
  handleVideoChange, handleVideoRemove, handleDrag, handleDrop,
  videoRecording, currentVideoField,
  startVideoRecording, stopVideoRecording, cancelVideoRecording,
}) => (
  <>
    {!planoPremium && (
      <PremiumWarning>
        <FaStar /> Apenas para plano premium
      </PremiumWarning>
    )}
    {modo !== TipoFormulario.tpVisualizacao && planoPremium && (
      <>
        <FileInput
          id={`file-input-${campo.nome}`}
          type="file"
          accept="video/*"
          onChange={(e) => {
            const fileInput = e.target as HTMLInputElement;
            const file = fileInput.files?.[0];
            if (file) {
              handleVideoChange?.(campo.nome, file);
              fileInput.value = '';
            }
          }}
        />
        <VideoUploadContainer
          className={dragActive?.[campo.nome] ? 'active' : ''}
          onClick={() => document.getElementById(`file-input-${campo.nome}`)?.click()}
          onDragEnter={(e) => handleDrag?.(e, campo.nome, true)}
          onDragLeave={(e) => handleDrag?.(e, campo.nome, false)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop?.(e, campo.nome, 'video')}
        >
          <UploadIcon><FaVideo /></UploadIcon>
          <UploadText>
            {dragActive?.[campo.nome]
              ? 'Solte o vídeo aqui'
              : 'Arraste e solte um vídeo ou clique para selecionar'}
          </UploadText>
        </VideoUploadContainer>
        <VideoControls>
          <VideoButton
            type="button"
            variant="primary"
            onClick={() => startVideoRecording?.(campo.nome)}
            disabled={videoRecording?.isRecording}
          >
            <FaCamera />
            {videoRecording?.isRecording && currentVideoField === campo.nome
              ? 'Gravando...'
              : 'Gravar Vídeo'}
          </VideoButton>
          {videoRecording?.isRecording && currentVideoField === campo.nome && (
            <>
              <VideoButton type="button" variant="secondary" onClick={stopVideoRecording}>
                <FaVideoSlash /> Parar
              </VideoButton>
              <VideoButton type="button" variant="danger" onClick={cancelVideoRecording}>
                <FaTimes /> Cancelar
              </VideoButton>
            </>
          )}
        </VideoControls>
      </>
    )}
    {videoPreview?.[campo.nome] && (
      <VideoContainer>
        <VideoPreview src={videoPreview[campo.nome]} controls />
        {modo !== TipoFormulario.tpVisualizacao && (
          <VideoControls>
            <VideoButton type="button" variant="danger" onClick={() => handleVideoRemove?.(campo.nome)}>
              <FaTrash /> Remover Vídeo
            </VideoButton>
          </VideoControls>
        )}
      </VideoContainer>
    )}
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
